import { downgradeComponent } from "@angular/upgrade/static";
import * as angular from "angular";
import "ng-debounce-throttle";
import { SplashScreenComponent } from "./splash-screen/splash-screen.component";
import { UnauthorizedViewComponent } from "./unauthorized-view/unauthorized-view.component";
//import { VideoCategoriesComponent } from "./videoCategories/videoCategories.component";

import { CoreModuleName } from "./_core/_core.directives.module.ajs";
import { FormModuleName } from "./_forms/_form.directives.module.ajs";
import "./_layout/_layout.directives.module.ajs";
import "./_layout/v-table/v-table.directives.module.ajs";
import "./_map/_map.directives.module.ajs";
import "./_misc/_misc.directives.module.ajs";
import "./_mouse/_mouse.directives.module";
import "./_resourceFilters/_resourceFilters.directives.module.ajs";
import "./_translations/_translations.directives.module.ajs";
import "./_vehicle/_vehicle.directives.module.ajs";

// We want the veri items first, so that later CSS can override these defaults
import "./_veri/_veri.directives.module.ajs";
import "./_visualisations/visualisations.module.ajs";

//const allowAttribute = directiveFactory => [
//    '$injector',
//    ($injector: angular.auto.IInjectorService) =>
//        Object.assign($injector.invoke(directiveFactory), { restrict: 'EA' }),
//];

//const downgradeAttributeComponent = info => allowAttribute(downgradeComponent(info));

angular
    .module("app.directives", [
        "ngDebounceThrottle",

        CoreModuleName,
        FormModuleName,
        "app.map.directives",
        "app.layout.directives",
        "app.vtable.directives",
        "app.resourceFilters.directives",
        "app.misc.directives",
        "app.translate.directives",
        "app.mouse.directives",
        "app.veri.directives",
        "app.vehicle.directives",
        "app.visualisations"
        /*"app.components.livemap"*/])

    .directive("splashScreen", downgradeComponent({ component: SplashScreenComponent }))
    .directive("unauthorizedView", downgradeComponent({ component: UnauthorizedViewComponent }))



    //.directive("resourceGroupDisplay", downgradeComponent({ component: ResourceGroupDisplayComponent }))

    //.component("pageFilterOptions", new PageFilterOptionsComponent())


    //.component("videoCategories", new VideoCategoriesComponent())

    .directive('bindHtmlCompile',
        [
            '$compile',  function ($compile) {
                return {
                    restrict: 'A',
                    link: function (scope: angular.IScope, element, attrs) {
                        scope.$watch(
                            () => {
                                return scope.$eval(attrs.bindHtmlCompile);
                            },
                            (value) => {
                                var rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
                                var sanitizedValue = (value && value.toString() || "").replace(rscript, "");

                                // In case value is a TrustedValueHolderType, sometimes it
                                // needs to be explicitly called into a string in order to
                                // get the HTML string.
                                //var value = scope.$eval(attrs.bindHtmlCompile);
                                element.html(sanitizedValue);

                                // If scope is provided use it, otherwise use parent scope
                                var compileScope = scope;

                                if (attrs.bindHtmlScope) {
                                    compileScope = scope.$eval(attrs.bindHtmlScope);
                                }

                                $compile(element.contents())(compileScope);
                            });
                    }
                };
            }
        ])
    
    .directive('fastBindAttrOnNotify', ['$parse', function ($parse) {
        var DEFAULT_EVENT_NAME = 'fast-bind-notify';

        return {
            compile: function compile(element, attributes) {
                var expr = $parse(attributes.fastBindAttrOnNotify),
                    name = attributes.fastBindOnNotifyName || DEFAULT_EVENT_NAME;

                return function link(scope, element, attrs) {
                    var lastValues = {};

                    scope.$on(name, () => {
                        var values = expr(scope);

                        angular.forEach(values, (value, key) => {

                            if (value !== lastValues[key]) {
                                attrs.$set(key as any, value);
                            }

                            lastValues[key] = value;
                        })
                    });
                };
            }
        };
    }])
    .directive('fastBindOnNotify', ['$parse', function ($parse) {
        var DEFAULT_EVENT_NAME = 'fast-bind-notify';

        return {
            compile: function compile(element, attributes) {
                var expr = $parse(attributes.fastBindOnNotify),
                    name = attributes.fastBindOnNotifyName || DEFAULT_EVENT_NAME;

                return function link(scope, element) {
                    var lastValue;
                    scope.$on(name, function () {
                        var value = expr(scope);

                        if (value !== lastValue) {
                            element.text(value);
                        }
                        lastValue = value;
                    });
                };
            }
        };
    }])
    .directive('fastBindAttrOnce', ['$parse', function ($parse) {
        return {
            compile: function compile(element, attributes) {
                var expr = $parse(attributes.fastBindAttrOnce);

                return function link(scope, element, attrs) {
                    var values = expr(scope);

                    angular.forEach(values, (value, key) => {
                        attributes.$set(key as any, value);
                    });
                };
            }
        };
    }])
    .directive('fastBindNotifier', ['$parse', function ($parse) {
        var Mode = {
            SHALLOW: 'shallow',
            DEEP: 'deep',
            COLLECTION: 'collection'
        };

        var DEFAULT_EVENT_NAME = 'fast-bind-notify',
            DEFAULT_MODE = Mode.SHALLOW;

        return {
            scope: true,
            compile: function compile(element, attributes) {
                var expr = $parse(attributes.fastBindNotifier),
                    name = attributes.fastBindNotifierName || DEFAULT_EVENT_NAME,
                    mode = attributes.fastBindNotifierMode || DEFAULT_MODE;

                return function link(scope, element) {
                    var handler = function handler(newValue, oldValue, scope) {
                        scope.$broadcast(name, newValue, oldValue);
                    };

                    switch (mode) {
                        case Mode.SHALLOW:
                        case Mode.DEEP:
                            scope.$watch(expr, handler, mode === Mode.DEEP);
                            break;

                        case Mode.COLLECTION:
                            scope.$watchCollection(expr, handler);
                            break;

                        default:
                            throw Error('fast-bind-notifier: Invalid mode "' + mode + '"');
                    }
                };
            }
        };
    }])
    .directive('fastBindOnce', ['$parse', function ($parse) {
        return {
            compile: function compile(element, attributes) {
                var expr = $parse(attributes.fastBindOnce);

                return function link(scope, element) {
                    element.text(expr(scope));
                };
            }
        };
    }])
    //;


    //.directive('dynamic', function ($compile) {
    //    return {
    //        restrict: 'A',
    //        replace: true,
    //        link: function (scope, ele, attrs) {
    //            scope.$watch(attrs.dynamic, (html: string) => {
    //                ele.html(html);
    //                $compile(ele.contents())(scope);
    //            });
    //        }
    //    };
    //});

    //https://github.com/spongessuck/gm.dragDrop
    //angular
    //.module('gm.dragDrop', [])
    .directive('gmDraggable', ['$window', '$document', gmDraggable])
    .directive('gmOnHover', gmOnHover)
    .directive('gmOnDrop', gmOnDrop);

var dragOb = null;

function apply(scope, attr, event = null) {
    scope.$apply(function () {
        scope.$eval(attr)(dragOb, event);
    });
}

function gmDraggable($window, $document) {
    return function (scope, element, attrs) {

        var startX = 0,
            startY = 0,
            clone = null,
            absParent = angular.element('<div></div>');

        var cancelWatch = null;

        // Handle will become a regular element, so if anything is returned,
        // we need to wrap that in angular.element(...) to bind events to it
        var handle = element[0].querySelectorAll('gm-drag-handle, [gm-drag-handle], .gm-drag-handle');
        (handle.length ? angular.element(handle) : element).on('mousedown', function (event) {
            // Prevent default dragging of selected content
            event.preventDefault();

            cancelWatch = scope.$watch(function () {
                return element.prop('innerHTML');
            }, function (val) {
                if (clone)
                    clone.prop('innerHTML', val);
            });

            dragOb = scope.$eval(attrs.gmDraggable);
            dragOb.$$gmDropZone = attrs.gmDropZone;

            clone = element.clone();
            element.addClass('gm-drag-element').after(clone);

            clone.css({
                position: 'relative',
                pointerEvents: 'none'
            }).addClass('gm-dragging');

            var elBoundingRect = element[0].getBoundingClientRect();

            absParent.css({
                position: 'absolute',
                zIndex: '2000',
                top: elBoundingRect.top + $window.scrollY + 'px',
                left: elBoundingRect.left + 'px',
                width: elBoundingRect.width + 'px'
            });
            $document.find('body').append(absParent);
            absParent.append(clone);

            startX = event.pageX;
            startY = event.pageY;
            $document.on('mousemove', mousemove);
            $document.on('mouseup', mouseup);
        });

        function mousemove(event) {
            clone.css({
                top: event.pageY - startY + 'px',
                left: event.pageX - startX + 'px'
            });
        }

        function mouseup() {
            if (dragOb) {
                if (attrs.gmOnInvalidDrop) {
                    apply(scope, attrs.gmOnInvalidDrop);
                }
                dragOb = null;
            }

            cancelWatch();

            //return;
            element.removeClass('gm-drag-element');

            clone.remove();
            absParent.remove();
            $document.off('mousemove', mousemove);
            $document.off('mouseup', mouseup);
        }
    };
}

function gmOnHover() {
    return function (scope, element, attr) {

        element.on('mouseover', function (e) {
            if (!dragOb)
                return;

            if (dragOb.$$gmDropZone == attr.gmDropZone) {
                apply(scope, attr.gmOnHover, e);
            }
        });
    }
}

function gmOnDrop() {
    return function (scope, element, attr) {
        element.on('mouseover', function () {
            if (!dragOb)
                return;

            if (dragOb.$$gmDropZone == attr.gmDropZone) {
                element.addClass('gm-dropping');
            }
        });

        element.on('mouseout', function () {
            if (!dragOb)
                return;

            element.removeClass('gm-dropping');
        });

        element.on('mouseup', function () {
            if (!dragOb)
                return;

            if (dragOb.$$gmDropZone == attr.gmDropZone) {
                apply(scope, attr.gmOnDrop);
                dragOb = null;
            }

            element.removeClass('gm-dropping');
        });
    }
}


;
